var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    { attrs: { bordered: false } },
    [
      _c(
        "div",
        { staticClass: "table-page-search-wrapper" },
        [
          _c(
            "a-form",
            {
              attrs: { layout: "inline" },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.searchQuery($event)
                }
              }
            },
            [
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: _vm.language["gift_user_app"] } },
                        [
                          _c("a-select", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseChoose"] +
                                _vm.language["gift_user_app"],
                              options: _vm.appList,
                              disabled: _vm.appLimit.flag
                            },
                            on: { change: _vm.handlerApp },
                            model: {
                              value: _vm.queryParam.app,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "app", $$v)
                              },
                              expression: "queryParam.app"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: _vm.language["gift_tag_name"] } },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["gift_tag_name"]
                            },
                            model: {
                              value: _vm.queryParam.label,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "label", $$v)
                              },
                              expression: "queryParam.label"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("a-col", { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } }, [
                    _c(
                      "span",
                      {
                        staticClass: "table-page-search-submitButtons",
                        staticStyle: { float: "left", overflow: "hidden" }
                      },
                      [
                        _c(
                          "a-button",
                          {
                            attrs: { type: "primary", icon: "search" },
                            on: { click: _vm.searchQuery }
                          },
                          [_vm._v(_vm._s(_vm.language["common.searchButton"]))]
                        ),
                        _c(
                          "a-button",
                          {
                            staticStyle: { "margin-left": "8px" },
                            attrs: { type: "primary", icon: "reload" },
                            on: { click: _vm.searchReset }
                          },
                          [_vm._v(_vm._s(_vm.language["common.resetButton"]))]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-operator" },
        [
          _c(
            "a-button",
            {
              directives: [
                {
                  name: "has",
                  rawName: "v-has",
                  value: "tag:add",
                  expression: "'tag:add'"
                }
              ],
              attrs: { type: "primary", icon: "plus" },
              on: { click: _vm.handleAdd }
            },
            [_vm._v(_vm._s(_vm.language["common.insertButton"]))]
          ),
          _c(
            "a-button",
            {
              directives: [
                {
                  name: "has",
                  rawName: "v-has",
                  value: "tag:export",
                  expression: "'tag:export'"
                }
              ],
              attrs: { type: "primary", icon: "download" },
              on: {
                click: function($event) {
                  return _vm.handleExportXls("商品標籤列表")
                }
              }
            },
            [_vm._v(_vm._s(_vm.language["common.exportButton"]))]
          ),
          _vm.selectedRowKeys.length > 0
            ? _c(
                "a-dropdown",
                [
                  _c(
                    "a-menu",
                    { attrs: { slot: "overlay" }, slot: "overlay" },
                    [
                      _c(
                        "a-menu-item",
                        { key: "1", on: { click: _vm.batchDel } },
                        [
                          _c("a-icon", { attrs: { type: "delete" } }),
                          _vm._v(
                            _vm._s(_vm.language["common.delete"]) + "\n        "
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-button",
                    {
                      directives: [
                        {
                          name: "has",
                          rawName: "v-has",
                          value: "tag:delete",
                          expression: "'tag:delete'"
                        }
                      ],
                      staticStyle: { "margin-left": "8px" }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.language["common.batchAction"]) +
                          "\n        "
                      ),
                      _c("a-icon", { attrs: { type: "down" } })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "div",
            {
              staticClass: "ant-alert ant-alert-info",
              staticStyle: { "margin-bottom": "16px" }
            },
            [
              _c("i", {
                staticClass: "anticon anticon-info-circle ant-alert-icon"
              }),
              _vm._v("  " + _vm._s(_vm.language["common.choosed"]) + " "),
              _c("a", { staticStyle: { "font-weight": "600" } }, [
                _vm._v(_vm._s(_vm.selectedRowKeys.length))
              ]),
              _vm._v(_vm._s(_vm.language["common.item"]) + "\n      "),
              _c(
                "a",
                {
                  staticStyle: { "margin-left": "24px" },
                  on: { click: _vm.onClearSelected }
                },
                [_vm._v(_vm._s(_vm.language["common.clear"]))]
              )
            ]
          ),
          _c("a-table", {
            ref: "table",
            staticClass: "j-table-force-nowrap",
            attrs: {
              size: "middle",
              scroll: { x: true },
              bordered: "",
              rowKey: "id",
              columns: _vm.columns,
              dataSource: _vm.dataSource,
              pagination: _vm.ipagination,
              loading: false,
              rowSelection: {
                selectedRowKeys: _vm.selectedRowKeys,
                onChange: _vm.onSelectChange
              }
            },
            on: { change: _vm.handleTableChange },
            scopedSlots: _vm._u([
              {
                key: "action",
                fn: function(text, record) {
                  return _c("span", {}, [
                    record.approveStatus === "0"
                      ? _c(
                          "div",
                          [
                            _c(
                              "a",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.handlePassAndRefuse(record, 1)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.language["gift_vendor_pass"]))]
                            ),
                            _c("a-divider", { attrs: { type: "vertical" } }),
                            _c(
                              "a",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.handlePassAndRefuse(record, 2)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.language["common.reject"]))]
                            )
                          ],
                          1
                        )
                      : _c(
                          "div",
                          [
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "has",
                                    rawName: "v-has",
                                    value: "tag:edit",
                                    expression: "'tag:edit'"
                                  }
                                ],
                                on: {
                                  click: function($event) {
                                    return _vm.handleEdit(record)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.language["common.edit"]))]
                            ),
                            _c("a-divider", { attrs: { type: "vertical" } }),
                            _c(
                              "a-dropdown",
                              [
                                _c(
                                  "a",
                                  { staticClass: "ant-dropdown-link" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.language["common.more"]) +
                                        "\n              "
                                    ),
                                    _c("a-icon", { attrs: { type: "down" } })
                                  ],
                                  1
                                ),
                                _c(
                                  "a-menu",
                                  {
                                    attrs: { slot: "overlay" },
                                    slot: "overlay"
                                  },
                                  [
                                    _c("a-menu-item", [
                                      _c(
                                        "a",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.handleDetail(record)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.language[
                                                "common.detailsButton"
                                              ]
                                            )
                                          )
                                        ]
                                      )
                                    ]),
                                    record.status === 0
                                      ? _c(
                                          "a-menu-item",
                                          {
                                            directives: [
                                              {
                                                name: "has",
                                                rawName: "v-has",
                                                value: "tag:delete",
                                                expression: "'tag:delete'"
                                              }
                                            ]
                                          },
                                          [
                                            _c(
                                              "a-popconfirm",
                                              {
                                                attrs: {
                                                  title:
                                                    _vm.language[
                                                      "common.deleteConfirmInfo"
                                                    ]
                                                },
                                                on: {
                                                  confirm: function() {
                                                    return _vm.handleDelete(
                                                      record.id
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("a", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.language[
                                                        "common.delete"
                                                      ]
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                  ])
                }
              },
              {
                key: "switchSlot",
                fn: function(status, record, idx) {
                  return _c(
                    "span",
                    {},
                    [
                      _c("a-switch", {
                        attrs: { checked: status },
                        on: {
                          click: function($event) {
                            return _vm.changeStatus(status, record, idx)
                          }
                        }
                      })
                    ],
                    1
                  )
                }
              }
            ])
          })
        ],
        1
      ),
      _c("product-tag-modal", {
        ref: "modalForm",
        attrs: { appList: _vm.appList },
        on: { ok: _vm.modalFormOk }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }